module.exports = __webpack_public_path__ + "static/media/leaveApplicationForm.74ee1535.pdf";